import { Component } from '@angular/core';
import { AppPermission } from '@app/shared/services/apps/apps.service';

@Component({
  standalone: false,
  selector: 'sbnb-breezeway',
  template: `
    <sbnb-apps-detail-page
      vendorCode="breezeway"
      name="Breezeway"
      logoTile="/assets/images/apps/breezeway-logo.png"
      builtBy="Breezeway"
      builtByLink="https://www.breezeway.io/"
      [categories]="['Operations']"
      [permissions]="[AppPermission.propertyListingRead, AppPermission.enrichmentRead, AppPermission.calendarRead]"
      email="vip@breezeway.io"
      phone="+1(857)600-2799"
      [beta]="false"
      [helpLink]="{
        href: 'https://www.breezeway.io/breezeway-hospitable-integrations',
        text: 'Automate your operations with Breezeway + Hospitable'
      }"
      [helpArticles]="[
        {
          id: '9121300',
          title:
            'Connect Hospitable with Breezeway to coordinate and communicate cleaning and maintenance at your property'
        }
      ]">
      <ng-container description>
        <p class="!mb-2">
          Breezeway's property operations and experience platform connects directly with Hospitable, helping you (1)
          save time coordinating turns, (2) easily track and pay your cleaners, and (3) boost revenue by offering more
          service to your guests.
        </p>

        <p>
          While Breezeway's full platform is just $19.99 per unit per month (which includes operations, guest messaging,
          guidebook tools), Hospitable users now get Breezeway operations free for their 1st unit. Click 'Get started'
          to sign up and redeem this offer.
        </p>
      </ng-container>
      <sbnb-image-carousel
        [images]="[
          '/assets/images/apps/breezeway/notification-center.png',
          '/assets/images/apps/breezeway/operations-insights.png',
          '/assets/images/apps/breezeway/property-schedule.png',
          '/assets/images/apps/breezeway/property-visibility.png',
          '/assets/images/apps/breezeway/user-availability.png'
        ]"></sbnb-image-carousel>
    </sbnb-apps-detail-page>
  `,
})
export class BreezewayComponent {
  public AppPermission = AppPermission;
}
